import React, { useRef } from "react";
import { useGetKYCStatusQuery } from "../../app/features/apiSlice";
import { Spinner } from "react-bootstrap";
import KycCard from "./KycCard";

const KycCardDashboard = () => {
  const sessionId = useRef(Date.now()).current;

  const { data, isLoading } = useGetKYCStatusQuery({
    sessionId,
  });
  if (isLoading) return <Spinner />;

  // Only show KYC card when kycRange is present (user has upgraded/invested)
  if (!data?.kycRange) return null;

  return <KycCard kycStatusKey={data} />;
};

export default KycCardDashboard;
